var FileSaver = require("file-saver");
import JsZip from "jszip";

// colHeaders is the headers for the CSV
// data is the actual data of the CSV
export function createCsvBlob(colHeaders, data) {
  const allData = [colHeaders || [], ...(data || [])];

  let csvContent = allData.map((e) => e.join(",")).join("\n");

  return new Blob([csvContent], { type: "text/csv;charset=utf-8" });
}

// zipName is the name of the zip file created
// files is an object with a name property specifying the file name and then a blob with the relevant data under the property content
export function zippedExport(zipName, files) {
  if (!zipName || !files) {
    return;
  }

  const zip = new JsZip();
  files.forEach((file) => {
    zip.file(file.name, file.content);
  });

  zip.generateAsync({ type: "blob" }).then((content) => {
    saveFile(zipName, content);
  });
}

// fileName is the name of the file to be exported
// blob is the blob that will be saved
export function saveFile(fileName, blob) {
  if (!fileName || !blob) {
    return;
  }

  FileSaver.saveAs(blob, fileName);
}

// repoName is included in the rows of the csv
// metrics is an array of metrics objects
export function createRepoMetricsCSVBlob(repoName, metrics) {
  let data = [];
  if (metrics) {
    data = metrics.map((e) => {
      return [
        repoName || "N/A",
        e.metricTimeStamp,
        e.trafficUnique,
        e.trafficCount,
        e.cloneUnique,
        e.forkCount,
        e.starCount,
      ];
    });
  }

  const headers = [
    "repo",
    "timestamp",
    "unique",
    "total",
    "clones",
    "forks",
    "stars",
  ];

  return createCsvBlob(headers, data);
}
